import { lazy } from "react";
import { PATHS } from "@/lib/router";
import { useAuthStore } from "@/features/auth/hooks";

const AdminOrganizationPage = lazy(
  () => import("./pages/AdminOrganizationPage"),
);
const OrganizationPage = lazy(() => import("./pages/OrganizationPage"));

const OrganizationEntry = () => {
  const { user } = useAuthStore();

  const isAdmin =
    user?.role === "business_unit" || user?.role === "system_admin";

  return isAdmin ? <AdminOrganizationPage /> : <OrganizationPage />;
};

export const organizationRoutes = [
  {
    path: PATHS.ORGANIZATION,
    element: <OrganizationEntry />,
    handle: { permission: { resource: "organization", action: "view" } },
  },
];
